/* STILL 18.7 · Ingyenes szállítás on the product page.
   Loaded by "STILL · Utánvét" (sections/nocta-v8-cod.liquid).
   1. The STILL Duo and the STILL Full Day say "Ingyenes szállítással" in every buy box (their price is
      above the free-shipping amount).
   2. Every buy box gets a shipping line under the stock line, for what is picked and how many:
      "Ingyenes szállítás · 1–3 munkanap alatt", or "Szállítás 1 990 Ft, 24 990 Ft-tól ingyenes" for one
      lens on its own. It takes the size of the stock line above it.
   The amounts come from the Releasit form's own shipping rates, so the page always says what the order
   form charges; the section's settings are used only if those cannot be read.
   18.8: looks again only when something changes in a buy box (not on every change anywhere on the page,
   such as a clock ticking or the order form drawing itself), and reads the stock line's size once per
   screen width instead of on every look (reading it made the browser restyle the page). */
(function () {
  'use strict';
  if (window.__nxShip) return;
  window.__nxShip = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var C = {};
  try { C = JSON.parse($('script[data-nx-ship-cfg]').textContent) || {}; } catch (e) { C = {}; }
  var T = {
    tag: C.tag || 'Ingyenes szállítással',
    free: C.free || 'Ingyenes szállítás · 1–3 munkanap alatt',
    paid: C.paid || 'Szállítás [price], [free]-tól ingyenes'
  };

  /* ---------- the rates: Releasit's, or the section's ---------- */
  function rates() {
    var free = null, price = null;
    try {
      (window._RSI_COD_FORM_SETTINGS.shippingRates.items_array || []).forEach(function (r) {
        (r.condition || []).forEach(function (c) {
          if (+r.price === 0 && /greater/.test(c.type) && (free === null || +c.value < free)) free = +c.value;
          if (+r.price > 0 && /less/.test(c.type) && (price === null || +r.price < price)) price = +r.price;
        });
      });
    } catch (e) { /* no Releasit on this page */ }
    if (free === null && +C.freeFrom > 0) free = Math.round(+C.freeFrom * 100);
    if (price === null && +C.price > 0) price = Math.round(+C.price * 100);
    return { free: free, price: price };
  }

  /* ---------- prices: every variant the STILL product sections sell ---------- */
  var V = {}, PAIRS = [], SET = null, FMT = null;
  function readPrices() {
    $$('script[data-nx-config]').forEach(function (el) {
      var c; try { c = JSON.parse(el.textContent); } catch (e) { return; }
      if (!c || typeof c !== 'object') return;
      if (c.moneyFormat && !FMT) FMT = c.moneyFormat;
      (c.variants || []).forEach(function (v) { if (v && v.id) V[String(v.id)] = v; });
      (c.pairs || []).forEach(function (v) { if (v && v.id) { V[String(v.id)] = v; if (PAIRS.indexOf(v) < 0) PAIRS.push(v); } });
      if (c.bundle && c.bundle.id) { V[String(c.bundle.id)] = c.bundle; SET = c.bundle; }
    });
  }
  function money(cents) {
    if (window.Still && typeof window.Still.formatMoney === 'function') return window.Still.formatMoney(cents, FMT);
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
  }

  var TRUCK = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true">' +
    '<path d="M2.5 5.25h8.75v8H2.5zM11.25 8h3.4l2.85 3.1v2.15h-6.25" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
    '<circle cx="6" cy="14.6" r="1.8" fill="currentColor"/><circle cx="14.6" cy="14.6" r="1.8" fill="currentColor"/></svg>';

  /* ---------- 1 · the Duo and the Full Day ---------- */
  function tag(host, show) {
    var el = $(':scope > [data-nx-free]', host);
    if (!show) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('span');
      el.className = 'nx-free';
      el.setAttribute('data-nx-free', '');
      el.innerHTML = TRUCK + '<span></span>';
      host.appendChild(el);
    }
    var t = $('span', el);
    if (t.textContent !== T.tag) t.textContent = T.tag;
  }

  /* ---------- 2 · the shipping line in every buy box ---------- */
  // the stock line's size: read once per box and screen width (the size only changes with the width)
  function stockSize(box, ref) {
    var w = window.innerWidth;
    if (box.__nxShipFs && box.__nxShipFsW === w && box.__nxShipRef === ref) return box.__nxShipFs;
    box.__nxShipFs = getComputedStyle(ref).fontSize;
    box.__nxShipFsW = w;
    box.__nxShipRef = ref;
    return box.__nxShipFs;
  }
  function line(box, R) {
    var form = $('form.nx-form', box);
    if (!form) return;
    var el = $('[data-nx-shipline]', box);
    if (!el) {
      el = document.createElement('p');
      el.className = 'nx-shipline';
      el.setAttribute('data-nx-shipline', '');
      el.innerHTML = TRUCK + '<span></span>';
    }
    // under the stock line ("Raktáron…"), else under "A csomagban…", else under the price
    var after = $('[data-nx-stock]', box) || $('[data-nx-contents]', box) || $('.nx-price-row', box);
    var ref = $('[data-nx-stock]', box);                  // phones set the stock line larger: the same here
    if (ref) { var fs = stockSize(box, ref); if (el.style.fontSize !== fs) el.style.fontSize = fs; }
    if (after && after.parentNode && after.nextElementSibling !== el) after.parentNode.insertBefore(el, after.nextSibling);
    else if (!after && el.parentNode !== form.parentNode) form.parentNode.insertBefore(el, form);
    var idIn = $('input[name="id"]', form), x = idIn && V[String(idIn.value)];
    var qIn = $('.nx-qty-n', box), n = Math.max(1, parseInt(qIn && qIn.value, 10) || 1);
    if (!x || R.free === null || (x.available === false)) { el.hidden = true; return; }
    var isFree = x.price * n >= R.free;
    var txt = isFree ? T.free : (R.price === null ? '' : T.paid.replace('[price]', money(R.price)).replace('[free]', money(R.free)));
    el.hidden = !txt;
    el.classList.toggle('is-free', isFree);
    var t = $('span', el);
    if (t.textContent !== txt) t.textContent = txt;
  }

  /* ---------- start ---------- */
  var queued = false;
  function sweep() {
    queued = false;
    if (!Object.keys(V).length) readPrices();
    var R = rates();
    if (R.free === null) return;
    var pairMin = PAIRS.reduce(function (m, p) { return m === null || p.price < m ? p.price : m; }, null);
    $$('.nx .nx-pairs-h').forEach(function (h) { tag(h, pairMin !== null && pairMin >= R.free); });
    $$('.nx .nx-bundle-t').forEach(function (h) { tag(h, !!SET && SET.price >= R.free); });
    $$('.nx .nx-box, .nx .nx-buy').forEach(function (box) {
      if (box.parentNode && box.parentNode.closest && box.parentNode.closest('.nx-box, .nx-buy')) return;
      line(box, R);
    });
  }
  // 18.8: what can change a shipping line: a change inside a buy box or a Duo / Full Day heading, or a
  // new one on the page (the theme editor). The lines and labels this script writes do not count.
  var HOT = '.nx-box, .nx-buy, .nx-pairs-h, .nx-bundle-t';
  var OURS = '[data-nx-shipline], [data-nx-free]';
  function ours(n) { return n.nodeType === 1 ? !!(n.matches(OURS) || n.closest(OURS)) : !!(n.parentElement && n.parentElement.closest(OURS)); }
  function matters(recs) {
    for (var i = 0; i < recs.length; i++) {
      var r = recs[i], t = r.target.nodeType === 1 ? r.target : r.target.parentElement;
      if (!t || !t.closest || t.closest(OURS)) continue;
      if (r.type === 'childList') {
        var mine = true, k;
        for (k = 0; k < r.addedNodes.length && mine; k++) mine = ours(r.addedNodes[k]);
        for (k = 0; k < r.removedNodes.length && mine; k++) mine = ours(r.removedNodes[k]);
        if (mine) continue;
      }
      if (t.closest(HOT)) return true;
      for (var j = 0; j < r.addedNodes.length; j++) {
        var n = r.addedNodes[j];
        if (n.nodeType === 1 && (n.matches(HOT) || n.querySelector(HOT))) return true;
      }
    }
    return false;
  }
  function start() {
    readPrices();
    document.addEventListener('shopify:section:load', readPrices);
    sweep();
    new MutationObserver(function (recs) {
      if (queued || !matters(recs)) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(sweep);
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-checked'] });
    document.addEventListener('nocta:qty', sweep);
    window.addEventListener('resize', function () {   // the stock line may change size with the width
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(sweep);
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
